export default "__VITE_ASSET__a33c7206__"